import { IconNames } from '@buggy/shared'
import { z } from 'zod'

export const iconTypeSchema = z.custom<IconNames>()
